import { useTranslation } from "react-i18next"
import { useProps } from "@/lib/page-rendering"

import { PageBody } from "@/components/ui/layout"

// The page Rails renders for a 404, 422 or 500, under the header like any
// other root page: the status and its message, then the way home. The
// header offers the rest of the recovery, the user's workspaces and Search.
export default function Page() {
  const { status } = useProps<{ status: number }>()
  const { t } = useTranslation("common")
  const message =
    status === 404
      ? "errors.not_found"
      : status === 422
        ? "errors.unprocessable"
        : status === 500
          ? "errors.server_error"
          : "errors.unexpected"

  return (
    <PageBody className="items-center justify-center py-24 text-center">
      <div className="text-8xl">{status}</div>
      <div className="text-lg">{t(message)}</div>
      <div className="mt-8">
        <a
          className="mx-2 h-10 rounded-full px-6 xl:mx-4 xl:h-11 xl:px-8 xl:text-lg"
          href="/"
        >
          {t("actions.home")}
        </a>
      </div>
    </PageBody>
  )
}
